// Regra pura do logout por inatividade (RQ-ACE-014): ativo até o limite, aviso de 60 s, depois sai.

export const AVISO_INATIVIDADE_MS = 60_000;
export const MINUTOS_INATIVIDADE_PADRAO = 30;

export type SituacaoInatividade =
  | { fase: 'ativo'; avisoEmMs: number }
  | { fase: 'aviso'; restanteMs: number }
  | { fase: 'sair' };

export function situacaoInatividade(ultimoMovimento: number, agora: number, limiteMinutos: number): SituacaoInatividade {
  const parado = agora - ultimoMovimento;
  const limite = limiteMinutos * 60_000;
  if (parado < limite) return { fase: 'ativo', avisoEmMs: limite - parado };
  if (parado < limite + AVISO_INATIVIDADE_MS) return { fase: 'aviso', restanteMs: limite + AVISO_INATIVIDADE_MS - parado };
  return { fase: 'sair' };
}

/** Cada aba usa o limite da empresa da sua URL. */
export function limiteDaEmpresa(empresas: { uuid: string; minutosInatividade: number }[], empresaUuid: string) {
  return empresas.find((e) => e.uuid === empresaUuid)?.minutosInatividade ?? MINUTOS_INATIVIDADE_PADRAO;
}
